<template>
    <div>
        <div class="table-responsive">
            <table class="table table-hover table-vertical-center table-head-bg">
                <thead v-if="!hideHeader">
                <tr>
                    <th>{{ __('sale.active_providers') }}</th>
                    <th class="text-right">{{ __('general.actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="provider of activePaymentProviders" :key="provider.id">
                    <td>
                        <img :src="provider.logo_url" :alt="provider.name" class="h-30px"/>
                    </td>
                    <td>
                        <div class="d-flex flex-row justify-content-end gap-1">
                            <button v-if="provider.id !== PaymentProvider.STRIPEID"
                                    class="btn btn-sm btn-light-primary text-nowrap"
                                    @click="setModalProvider(provider.id)"
                                    type="button"
                            >
                                <i class="fas fa-edit"/>
                                {{ __('actions.change.index') }}
                            </button>
                            <div v-if="provider.id === PaymentProvider.STRIPEID && stripeIsReady">
                                <a target="_blank" href="https://dashboard.stripe.com/dashboard">
                                    <button class="btn btn-sm btn-light-info stripe-connect pr-0">
                                        <span>{{ __('sale.stripe.dashboard') }}</span>
                                    </button>
                                </a>
                            </div>
                            <button class="btn btn-sm btn-light-danger text-nowrap"
                                    @click="deletePaymentProvider(provider.id)"
                            >
                                <i class="fas fa-trash"/>
                                {{ __('actions.remove') }}
                            </button>
                        </div>
                    </td>
                    <update-account-modal v-if="selectedProvider === provider.id" :key="provider.id"
                                          :ref="'updateModal' + provider.id"
                                          :provider="provider"
                                          get-account-details/>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>
import UpdateAccountModal from './UpdateAccountModal.vue'
import {PaymentProviderMixin} from '@mixins/payment_providers'

export default {
    mixins: [PaymentProviderMixin],

    components: {UpdateAccountModal},

    props: {
        activePaymentProviders: Array,
        stripeIsReady: Boolean,
        hideHeader: Boolean
    },

    data() {
        return {
            selectedProvider: undefined,
        }
    },

    methods: {
        setModalProvider(id) {
            this.selectedProvider = id
            setTimeout(() => {
                this.$refs['updateModal' + id][0].openModal()
            }, 500)
        },

        async deletePaymentProvider(providerId) {
            await Swal.fire({
                title: this.__('sale.remove_provider.title'),
                text: this.__('sale.remove_provider.text'),
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: this.__('general.yes'),
                cancelButtonText: this.__('actions.abort'),
                width: '75%',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$inertia.post(this.$route('delete.account.details', {
                        storeUuid: this.$page.props.storeUuid,
                        payment_provider_id: providerId,
                    }), {})
                }
            })
        },
    },
}
</script>
